export const HTTP_METHODS = {
  GET: "GET",
  POST: "POST",
  PUT: "PUT",
  PATCH: "PATCH",
  DELETE: "DELETE"
} as const

export const AUTH_VIEW = {
  REGISTER: "register",
  REGISTER_VERIFY: "registerVerify"
}

export const ROLES = {
  AGENT: "AGENT",
  ADMIN: "admin"
}
export const STATUS_CODE = {
  SUCCESS: 200,
  UNAUTHORIZED: 401,
  PARTIAL_SUCCESS: 206
}
export const LOAD_MORE_SIZE = { width: "40px", height: "40px" }
export const CALL_DIRECTION = {
  INCOMING: "incoming",
  OUTBOUND: "outbound"
}
export const PROVIDERS = {
  TWILIO: "twilio",
  TELNYX: "telnyx"
} as const

export type IPROVIDERS = keyof typeof PROVIDERS

export const CALL_STATE = {
  DESTROY: "destroy",
  NEW: "new",
  REQUESTING: "requesting",
  TRYING: "trying",
  ANSWERING: "answering",
  RINGING: "ringing",
  PENDING: "pending",
  ACTIVE: "active",
  CONNECTING: "connecting",
  ACCEPTED: "accepted",
  HELD: "held"
} as const
